import React from "react";
import { Table } from "antd";

const PatientRecipientTable = ({ t, dataSource }) => (
  <Table
    dataSource={dataSource}
    columns={[
      {
        title: t("patient.general.phone"),
        dataIndex: "phone",
        render: (text, item) => <span id="patient-info-phone-text">{item.patientPhone || "-"}</span>,
        key: "phone"
      },
      {
        title: t("patient.general.email"),
        dataIndex: "email",
        render: (text, item) => <span id="patient-info-email-text">{item.patientEmail || "-"}</span>,
        key: "email"
      },
      {
        title: t("patient.general.address"),
        dataIndex: "address",
        render: (text, item) => <span id="patient-info-address-text">{item.patientAddress || "-"}</span>,
        key: "address"
      },
      {
        title: t("patient.general.ssn"),
        dataIndex: "social_security_number",
        render: (text, item) => <span id="patient-info-ssn-text">{item.socialSecurityNumber || "-"}</span>,
        key: "ssn"
      }
    ]}
    pagination={false}
  />
);

export { PatientRecipientTable };
